import { apiPOST, API_URI } from './api';
import { setUIProperty } from '../actions';

const KEY_AUTH = 'auth';
let inMemoryToken;
export const AUTH_NAMESPACE = 'auth';
export const AUTH_ACTION_REQUEST_AUTHORIZATION = 'AUTHORIZE_REQUEST';
export const AUTH_ACTION_REQUEST_RENEWAL = 'AUTHORIZE_RENEWAL';
export const AUTH_ACTION_AUTHORIZE = 'AUTHORIZE';
export const AUTH_ACTION_DEAUTHORIZE = 'DEAUTHORIZE';
export const AUTH_ACTION_REGISTER = 'AUTHORIZE';

export const authLogin = (username, password) => dispatch => {
  dispatch({
    type: `${AUTH_NAMESPACE}/${AUTH_ACTION_REQUEST_AUTHORIZATION}`,
    service: 'password',
  });
  return dispatch(apiPOST('auth/artsteps', { username, password })).then(({ response }) => {
    if (response.error) {
      storeCredentials(null);
      return dispatch({
        type: `${AUTH_NAMESPACE}${AUTH_ACTION_DEAUTHORIZE}`,
        service: 'password',
        response,
      });
    }
    storeCredentials(response);
    return dispatch({
      type: `${AUTH_NAMESPACE}/${AUTH_ACTION_AUTHORIZE}`,
      service: 'password',
      response,
    });
  });
};

export const authRenew = (token, user) => dispatch => {
  dispatch({
    type: `${AUTH_NAMESPACE}/${AUTH_ACTION_REQUEST_RENEWAL}`,
  });
  return dispatch(apiPOST('auth/renew-jwt', { timestamp: Date.now() }));
};

export const authRegister = user => dispatch => {
  dispatch({
    type: `${AUTH_NAMESPACE}/${AUTH_ACTION_REGISTER}`,
    service: 'password',
  });
  return dispatch(apiPOST('users', user));
};

export const oauthLogin = service => dispatch => {
  dispatch({
    service,
    type: `${AUTH_NAMESPACE}/${AUTH_ACTION_REQUEST_AUTHORIZATION}`,
  });
  return new Promise(resolve => {
    const win = window.open(`${API_URI}/auth/${service}`, 'oauth', 'height=600,width=450');
    window.onOAuth = response => {
      storeCredentials(response);
      win.close();
      resolve({ response });
    };
  }).then(() => dispatch(restoreAuth()));
};

export const authLogout = () => dispatch => {
  storeCredentials(null);
  dispatch(setUIProperty('unverifiedNotificationOpen', true));
  return Promise.resolve(
    dispatch({
      type: `${AUTH_NAMESPACE}/${AUTH_ACTION_DEAUTHORIZE}`,
      response: {},
    }),
  );
};

export const restoreAuth = () => dispatch =>
  dispatch(authRenew())
    .then(resA => resA.response && storeCredentials(resA.response))
    .then(resB => {
      const credentials = getStoredCredentials();
      if (credentials && credentials.token && isTokenValid(credentials.token)) {
        return Promise.resolve(
          dispatch({
            type: `${AUTH_NAMESPACE}/${AUTH_ACTION_AUTHORIZE}`,
            response: credentials,
          }),
        );
      }
      return Promise.resolve(
        dispatch({
          type: `${AUTH_NAMESPACE}/${AUTH_ACTION_DEAUTHORIZE}`,
          response: credentials,
        }),
      );
    });

export const isTokenExpiring = token => {
  const expireWindow = 60 * 5; // in seconds
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp < Date.now() / 1000 + expireWindow;
  } catch (err) {
    return false;
  }
};

const isTokenValid = token => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch (err) {
    return false;
  }
};

export const getStoredCredentials = () => {
  try {
    return inMemoryToken
      ? { ...JSON.parse(localStorage.getItem(KEY_AUTH)), token: inMemoryToken }
      : null;
  } catch (ignore) {
    return null;
  }
};

export const storeCredentials = credentials => {
  try {
    if (credentials && credentials.token) {
      inMemoryToken = credentials.token;
      localStorage.setItem(
        KEY_AUTH,
        JSON.stringify(
          Object.keys(credentials).reduce(
            (acc, cur) => ({ ...acc, ...(cur !== 'token' ? { [cur]: credentials[cur] } : {}) }),
            {},
          ),
        ),
      );
    } else {
      inMemoryToken = null;
      localStorage.removeItem(KEY_AUTH);
    }
    return getStoredCredentials();
  } catch (ignore) {
    return null;
  }
};
